<template>
  <div class="create-collection">
    <div
      class="create-collection-btn"
      @click="handleCreateCollection"
    >
      CREATE COLLECTION
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia/dist/pinia';
import { useRMTStore } from '@/store/RMTStore';
import {useCollectionStore} from '@/store/CollectionStore';

export default {
  name: 'CreateCollection',
  computed: {
    ...mapStores(useRMTStore)
  },
  methods: {
   handleCreateCollection () {
     /*     if (this.RMTStore.selectedCollections.length !== 0) {
           this.RMTStore.selectedCollections[0].isSelected = false;
         }
         this.RMTStore.isAddResource = false;
         this.RMTStore.selectedCollectionColor = null,
         this.RMTStore.uploadedFileData = [];
         this.createData = [{
             title: null,
             cID: null,
             subscription: null,
             description: null,
             tagIds: [],
             resources: [],
           }];
         this.RMTStore.setUploadedCollections(this.createData);
         this.RMTStore.setCancelMode(1);*/

      this.RMTStore.clearAll();
      this.RMTStore.clearAssociations();

      this.RMTStore.inCreateCollectionMode = true;
      this.RMTStore.panelIsHidden = false;
      this.RMTStore.inMultiSelectionMode = true;

      // todo: fix default data
      // this.RMTStore.data = this.RMTStore.getDefaultData;


      this.RMTStore.selectedCollections = [];
      this.RMTStore.selectedCollections.push(
          Object.assign({}, useCollectionStore().getDefaultCollectionData)
      );
    },
  }
};
</script>

<style scoped>
.create-collection {
  display: flex;
  height: 30px;
}
.create-collection-btn {
  cursor: pointer;
  background-color: #72b9f3;
  color: white;
  width: 160px;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: .8em;
  font-weight: 900;
  letter-spacing: .07em;
  transition: background-color .2s;
}
.create-collection-btn:hover {
  background-color: #58a0da;
}
</style>